"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../../button");

var _icons = require("../../../icons");

var _layout = require("../../../layout");

var _screenReaderOnly = require("../../../screen-reader-only");

var _utils = require("../../../utils");

var _InputSegment = _interopRequireDefault(require("./InputSegment"));

var _constants = require("./constants");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Modeled after DateTimeSegment, modified to work with am/pm instead of numbers
var PeriodSegment = function PeriodSegment(_ref) {
  var id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      isReadOnly = _ref.isReadOnly,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder,
      shouldFocus = _ref.shouldFocus,
      onFocus = _ref.onFocus,
      focusPreviousSegment = _ref.focusPreviousSegment,
      focusNextSegment = _ref.focusNextSegment,
      showSpinButtons = _ref.showSpinButtons,
      ariaLabel = _ref.ariaLabel,
      ariaLabelledBy = _ref.ariaLabelledBy,
      ariaDescribedBy = _ref.ariaDescribedBy,
      ariaRequired = _ref.ariaRequired,
      ariaInvalid = _ref.ariaInvalid,
      increaseAriaLabel = _ref.increaseAriaLabel,
      decreaseAriaLabel = _ref.decreaseAriaLabel;

  var _useState = (0, _react.useState)(value || ''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showAnnounce = _useState4[0],
      setShowAnnounce = _useState4[1];

  var handleStopAnnounce = function handleStopAnnounce() {
    setShowAnnounce(false);
  };

  var handleButtonClick = function handleButtonClick() {
    swapValue();
    setShowAnnounce(true);
  };

  (0, _react.useEffect)(function () {
    if (fieldRef.current && shouldFocus) {
      fieldRef.current.focus();
    }
  }, [shouldFocus]);
  (0, _react.useEffect)(function () {
    if (value === undefined) setStateValue('');else setStateValue(value);
  }, [value, stateValue]);
  var fieldRef = (0, _react.useRef)(null);

  var swapValue = function swapValue() {
    var newValue = stateValue === 'AM' ? 'PM' : 'AM';
    setStateValue(newValue);
    onChange(newValue, name);
  };

  var handleLetter = function handleLetter(code) {
    var newValue = undefined;
    if (code === 'KeyA') newValue = 'AM';
    if (code === 'KeyP') newValue = 'PM';

    if (!!newValue) {
      setStateValue(newValue);
      onChange(newValue, name);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    var preventDefault = true;

    if (['KeyA', 'KeyP'].includes(e.code)) {
      handleLetter(e.code);
      return;
    }

    switch (e.key) {
      case _utils.EventKeys.BACKSPACE:
      case _utils.EventKeys.DELETE:
        setStateValue('');
        onChange(undefined, name);
        break;

      case _utils.EventKeys.ARROW_UP:
      case _utils.EventKeys.ARROW_DOWN:
      case _utils.EventKeys.PAGE_UP:
      case _utils.EventKeys.PAGE_DOWN:
      case _utils.EventKeys.HOME:
      case _utils.EventKeys.END:
        swapValue();
        break;

      case _utils.EventKeys.ARROW_LEFT:
        focusPreviousSegment();
        break;

      case _utils.EventKeys.ARROW_RIGHT:
        focusNextSegment();
        break;

      case _utils.EventKeys.TAB:
        preventDefault = false;
        break;

      default:
        break;
    }

    if (preventDefault) {
      e.preventDefault();
    }
  };

  var handleMouseDown = function handleMouseDown(e) {
    e.preventDefault();

    if (fieldRef.current) {
      fieldRef.current.focus();
    }
  };

  var handleFocus = function handleFocus() {
    onFocus(name);
  };

  return (0, _core.jsx)(_layout.Col, {
    gridGap: "S100",
    alignItems: "center"
  }, showAnnounce && (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    "aria-live": "polite",
    role: "status"
  }, stateValue, " ", ariaLabel), showSpinButtons && (0, _core.jsx)(_button.Button, {
    "aria-label": increaseAriaLabel,
    icon: (0, _core.jsx)(_icons.IconChevronUp, {
      size: _icons.IconSize.ExtraSmall,
      "aria-hidden": true
    }),
    onBlur: handleStopAnnounce,
    onClick: handleButtonClick,
    tabIndex: -1,
    variant: _button.ButtonVariant.Tertiary
  }), (0, _core.jsx)(_InputSegment.default, {
    id: id,
    role: "spinbutton",
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    "aria-required": ariaRequired,
    "aria-invalid": ariaInvalid,
    "aria-valuenow": stateValue,
    value: stateValue,
    width: _constants.segmentInfo[name].width,
    readOnly: isReadOnly,
    disabled: disabled,
    type: "text",
    placeholder: placeholder,
    autoComplete: "off",
    spellCheck: false,
    ref: fieldRef,
    onChange: function onChange() {
      return null;
    },
    onKeyDown: handleKeyDown,
    onMouseDown: handleMouseDown,
    onFocus: handleFocus
  }), showSpinButtons && (0, _core.jsx)(_button.Button, {
    "aria-label": decreaseAriaLabel,
    icon: (0, _core.jsx)(_icons.IconChevronDown, {
      size: _icons.IconSize.ExtraSmall,
      "aria-hidden": true
    }),
    onBlur: handleStopAnnounce,
    onClick: handleButtonClick,
    tabIndex: -1,
    variant: _button.ButtonVariant.Tertiary
  }));
};

var _default = PeriodSegment;
exports.default = _default;